import React from 'react';

const MeteringPump4Icon = ({
  width = 64,
  height = 64,
  className = '',
  startColor = '#373737',
  midColor = '#EBEBEB',
  endColor = '#373737'
}) => {
  const uid = React.useId ? React.useId() : 'sc' + Math.random().toString(36).substr(2, 9);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 112.5 106.646"
      className={className}
    >

<g id={`${uid}_1`}>
	<path fill={`${midColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M13.176,60.925h72.297l1.914-1.914H15.09L13.176,60.925z" />
	<path fill={`${endColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M76.014,57.997H30.743v2.364h45.271V57.997z" />
	<path fill={`${endColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M72.973,57.997H33.896l1.689-2.141h35.36L72.973,57.997z" />
	<path fill={`${endColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M73.198,53.379L72.41,55.18l-1.465,0.676H36.036l-1.464-0.676   l-0.451-1.802V7.884l19.257-1.237l19.82,1.237V53.379z" />
</g>
<g id={`${uid}_2`}>
	<path fill={`${midColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M32.658,7.884l3.941-0.225V53.38l-1.014,1.015l-2.14-1.69   l-0.788-1.239L32.658,7.884L32.658,7.884z" />
	<path fill={`${midColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M36.824,7.659l3.378-0.225v46.733l-0.788,0.227L37.5,53.379   l-0.676-2.14V7.659z" />
	<path fill={`${midColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M40.878,7.434l2.703-0.226v46.959l-0.563,0.227l-2.14-2.93V7.434z" />
	<path fill={`${midColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M44.82,7.208l2.59-0.338v47.297l-0.45,0.227l-2.14-3.154V7.208z" />
	<path fill={`${midColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M48.874,6.871l1.914-0.225v47.297l-0.563,0.451l-1.351-3.154V6.871z" />
	<path fill={`${endColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M54.392,6.646h-1.014h-0.676v44.818l1.689,3.153v-0.676L54.392,6.646   L54.392,6.646z" />
	<path fill={`${endColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M56.306,6.871h2.139v47.297l-0.225,0.227l-1.916-3.154L56.306,6.871   L56.306,6.871z" />
	<path fill={`${endColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M59.686,6.871l2.701,0.338v46.734l-0.225,0.226l-2.479-2.928V6.871   H59.686z" />
	<path fill={`${endColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M63.738,7.208l2.928,0.226v46.509l-0.675,0.451l-2.253-3.154V7.208z" />
	<path fill={`${endColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M67.117,7.434l3.379,0.225v46.284l-0.676,0.451l-2.703-3.154V7.434z" />
</g>
<g id={`${uid}_3`}>
	<path stroke={`${startColor}`} strokeWidth="0.25" d="M65.991,0.001H39.978l-5.405,0.676l-2.14,1.689v5.518h40.991V2.366l-2.141-1.689   L65.991,0.001z" fill={`${midColor}`} />
</g>
<g id={`${uid}_4`}>
	<path fill={`${midColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M74.887,56.758h-1.238v1.239h1.238V56.758z" />
	<path fill={`${midColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M31.757,56.758h1.464v1.239h-1.464V56.758z" />
	<path fill={`${midColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M42.567,56.758h1.464v1.239h-1.464V56.758z" />
	<path fill={`${midColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M54.392,56.758h1.464v1.239h-1.464V56.758z" />
	<path fill={`${midColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M64.979,56.758h1.463v1.239h-1.463V56.758z" />
</g>
<g id={`${uid}_5`}>
	<path d="M5.968,73.199h9.459v5.293H5.968V73.199z" fill={`${midColor}`} />
	
		<linearGradient id={`${uid}_6`} gradientUnits="userSpaceOnUse" x1="4.3364" y1="22.073" x2="4.3364" y2="40.4285" gradientTransform="matrix(1 0 0 -1 0 106.646)">
		<stop offset="0.01" style={{stopColor: `${startColor}`}} />
		<stop offset="0.51" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_6)`} stroke={`${startColor}`} strokeWidth="0.25" d="M3.266,66.218h2.703l1.915,0.677l0.789,1.914l-0.789,6.53   l0.789,6.531l-0.789,1.915l-1.915,0.788H3.266l-1.914-0.788L0.676,81.87L0,75.114l0.676-6.307l0.676-1.914L3.266,66.218z" />
</g>
<g id={`${uid}_7`}>
	<path fill={`${midColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M95.158,94.37L82.32,88.853l2.928,11.711l9.121-2.814L95.158,94.37z" />
	<path fill={`${midColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M5.518,97.523h86.486v9.122H5.518V97.523z" />
	<path fill={`${midColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M95.158,94.37l-3.154,3.153v9.122l3.154-2.929V94.37z" />
	
		<linearGradient id={`${uid}_8`} gradientUnits="userSpaceOnUse" x1="6.4189" y1="12.6135" x2="92.0039" y2="12.6135" gradientTransform="matrix(1 0 0 -1 0 106.646)">
		<stop offset="0.01" style={{stopColor: `${endColor}`}} />
		<stop offset="0.51" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${endColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_8)`} stroke={`${startColor}`} strokeWidth="0.25" d="M6.419,97.523h85.585l-6.306-6.981H11.824L6.419,97.523z" />
	<path fill={`${midColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M10.585,97.298h6.194v-2.139h-6.194V97.298z" />
	<path fill={`${midColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M79.393,97.298h6.08v-2.139h-6.08V97.298z" />
</g>
<g id={`${uid}_9`}>
	
		<linearGradient id={`${uid}_10`} gradientUnits="userSpaceOnUse" x1="47.7476" y1="16.1042" x2="47.7476" y2="45.7214" gradientTransform="matrix(1 0 0 -1 0 106.646)">
		<stop offset="0.01" style={{stopColor: `${endColor}`}} />
		<stop offset="0.51" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${endColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_10)`} d="M12.951,60.925h72.748v29.617H9.797V74.889l0.225-4.167l0.563-4.505l0.901-3.604l0.789-1.239   L12.951,60.925z" />
	<path fill="none" stroke={`${startColor}`} strokeWidth="0.25" d="M18.468,90.542V74.889l0.226-4.167l0.563-4.505l0.901-3.604l0.676-1.239   l0.788-0.45" />
	<path fill="none" stroke={`${startColor}`} strokeWidth="0.25" d="M25.451,90.542V74.889l0.225-4.167l0.563-4.505l0.901-3.604l0.676-1.239   l0.788-0.45" />
	<path fill="none" stroke={`${startColor}`} strokeWidth="0.25" d="M32.433,90.542V74.889l0.225-4.167l0.563-4.505l0.901-3.604l0.788-1.239   l0.676-0.45" />
	<path fill="none" stroke={`${startColor}`} strokeWidth="0.25" d="M39.415,90.542V74.889v-4.167l0.788-4.505l0.901-3.604l0.563-1.239   l0.901-0.45" />
	<path fill="none" stroke={`${startColor}`} strokeWidth="0.25" d="M46.171,90.542V74.889l0.225-4.167l0.563-4.505l0.901-3.604l0.788-1.239   l0.901-0.45" />
	<path fill="none" stroke={`${startColor}`} strokeWidth="0.25" d="M53.153,90.542V74.889l0.225-4.167l0.563-4.505l0.901-3.604l0.789-1.239   l0.675-0.45" />
	<path fill="none" stroke={`${startColor}`} strokeWidth="0.25" d="M60.135,90.542V74.889l0.227-4.167l0.563-4.505l0.9-3.604l0.789-1.239   l0.675-0.45" />
	<path fill="none" stroke={`${startColor}`} strokeWidth="0.25" d="M67.117,90.542V74.889v-4.167l0.787-4.505l0.902-3.604l0.787-1.239   l0.676-0.45" />
	<path fill="none" stroke={`${startColor}`} strokeWidth="0.25" d="M74.1,90.542V74.889v-4.167l0.787-4.505l0.901-3.604l0.563-1.239   l0.899-0.45" />
	
		<linearGradient id={`${uid}_11`} gradientUnits="userSpaceOnUse" x1="89.1895" y1="13.9646" x2="89.1895" y2="52.2517" gradientTransform="matrix(1 0 0 -1 0 106.646)">
		<stop offset="0.01" style={{stopColor: `${startColor}`}} />
		<stop offset="0.51" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_11)`} stroke={`${startColor}`} strokeWidth="0.25" d="M92.68,54.394h-6.98v38.287h6.98V54.394" />
</g>
<g id={`${uid}_12`}>
	
		<linearGradient id={`${uid}_13`} gradientUnits="userSpaceOnUse" x1="97.0723" y1="20.4968" x2="97.0723" y2="41.4421" gradientTransform="matrix(1 0 0 -1 0 106.646)">
		<stop offset="0" style={{stopColor: `${endColor}`}} />
		<stop offset="0.51" style={{stopColor: `${midColor}`}} />
		<stop offset="0.99" style={{stopColor: `${midColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_13)`} d="M102.365,65.204H91.779v20.945h10.586V65.204z" />
	<path fill={`${endColor}`} d="M102.365,85.023H91.779v1.126h10.586V85.023z" />
	<path fill={`${endColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M99.662,65.204l-2.141,0.226l-2.14-0.226V54.618h4.279L99.662,65.204   L99.662,65.204z" />
	<path fill={`${endColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M102.365,63.29h2.814v24.887h-2.814V63.29z" />
	<path fill={`${endColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M112.5,65.429h-7.32v6.081h7.32V65.429z" />
</g>
    </svg>
  );
};

export default MeteringPump4Icon;
